import { render, staticRenderFns } from "./AnImage.vue?vue&type=template&id=4571824d&scoped=true&"
import script from "./AnImage.vue?vue&type=script&lang=ts&"
export * from "./AnImage.vue?vue&type=script&lang=ts&"
import style0 from "./AnImage.vue?vue&type=style&index=0&id=4571824d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4571824d",
  null
  
)

export default component.exports